export const STATISTICS_REQUEST = 'STATISTICS_REQUEST';
export const STATISTICS_SUCCESS = 'STATISTICS_SUCCESS';
export const STATISTICS_FAILURE = 'STATISTICS_FAILURE';
